export const settings = {
  postback: {
    title: 'Setup',
    url: {
      title: 'Postback URL',
      placeholder: 'Enter URL',
      save: 'Save'
    }
  },

  check: {
    title: 'Phone check',
    verification_type: 'Verification type',
    phone: {
      title: 'Phone',
      placeholder: 'Input your phone number',
      button: 'Send'
    },
    code: {
      title: 'SMS-code',
      placeholder: 'Security code'
    }
  }
};
